// The game data files of `src/data/`, checked and linked once at load.
import islandData from '../data/island.json';
import example from '../data/sim/example.json';
import items from '../data/sim/items.json';
import machines from '../data/sim/machines.json';
import orders from '../data/sim/orders.json';
import prototype from '../data/sim/prototype.json';
import recipes from '../data/sim/recipes.json';
import start from '../data/sim/start.json';
import terrains from '../data/sim/terrains.json';
import vehicles from '../data/sim/vehicles.json';
import { parseIsland } from '../world/island';
import { parseGameData, type GameData, type RawGameData } from './data';
import { parseScenario, type Scenario } from './simulation';

export const RAW_GAME_DATA: RawGameData = { items, recipes, machines, terrains, vehicles, orders, prototype };

export function loadGameData(raw: RawGameData = RAW_GAME_DATA): GameData {
  return parseGameData(raw, parseIsland(islandData));
}

/** The example scenario: the first chain of the prototype, fully built (PRD section 18). */
export function loadExampleScenario(): Scenario {
  return parseScenario(example);
}

/** The start of a new game in H2: the two truck routes of the first chain, with the workshop still empty. */
export function loadStartScenario(): Scenario {
  return parseScenario(start);
}
